import { LucideIcon } from 'lucide-react'
import { ReactNode } from 'react'

import { Button, ButtonProps } from '../button'
import { Tooltip, TooltipContent, TooltipTrigger } from '../tooltip'

interface Props extends ButtonProps {
    tooltip?: ReactNode
    icon: LucideIcon
}

export default function IconButton({ icon, tooltip, ...props }: Props) {
    const Icon = icon

    const button = (
        <Button size="sm" variant="ghost" {...props}>
            <Icon className="h-4 w-4" />
        </Button>
    )

    if (!tooltip) {
        return button
    }

    return (
        <Tooltip delayDuration={250}>
            <TooltipTrigger>{button}</TooltipTrigger>
            <TooltipContent>{tooltip}</TooltipContent>
        </Tooltip>
    )
}
